import { render, staticRenderFns } from "./FailIcon.vue?vue&type=template&id=ca1c645e&scoped=true"
import script from "./FailIcon.vue?vue&type=script&lang=js"
export * from "./FailIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1c645e",
  null
  
)

export default component.exports